import CommentsIntegration from './integration/comments-integration';
import TrackChangesIntegration from './integration/trackchanges-integration';
import UsersIntegration from './integration/users-integration';
import SpecialCharactersCheckMarks from './check-mark/checkmark';
import FontColor from './font-color/fontcolor';
import FootNote from './footnote/footnote';
import LineHeight from './line-height/lineheight';
import ReadOnly from './read-only/readonly';
import Placeholder from './placeholder/placeholder';

export {
    CommentsIntegration,
    TrackChangesIntegration,
    UsersIntegration,
    SpecialCharactersCheckMarks,
    FontColor,
    FootNote,
    LineHeight,
    ReadOnly,
    Placeholder
};
